import { AbstractModel } from '@/models/abstractModel';
import { currencyExchangeRateFields, type CurrencyExchangeRateKey } from '@/models/currencyExchangeRates';
import type { ICurrencyExchangeApi } from '@/types/currencyExchange';

function parseRatePayload(rate: ICurrencyExchangeApi['rate']): Record<string, number | string> {
    if (rate == null || rate === '') return {};
    if (typeof rate === 'object') return rate;

    try {
        const parsed = JSON.parse(rate);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
}

function emptyRates(): Record<CurrencyExchangeRateKey, string | null> {
    return Object.fromEntries(currencyExchangeRateFields.map(({ key }) => [key, null])) as Record<CurrencyExchangeRateKey, string | null>;
}

export class CurrencyExchangeItem extends AbstractModel {
    public createdAt: string = '';
    public id: number = 0;
    public rates: Record<CurrencyExchangeRateKey, string | null> = emptyRates();

    constructor(data?: ICurrencyExchangeApi) {
        super();

        if (!data) {
            return;
        }

        this.id = data.id;
        this.createdAt = data.created_at;

        const parsed = parseRatePayload(data.rate);
        for (const { key } of currencyExchangeRateFields) {
            const value = parsed[key];
            this.rates[key] = value == null || value === '' ? null : String(value);
        }
    }

    static createEmpty(): CurrencyExchangeItem {
        return new CurrencyExchangeItem();
    }

    static fromLatest(latest: CurrencyExchangeItem | null | undefined): CurrencyExchangeItem {
        const item = CurrencyExchangeItem.createEmpty();
        if (!latest) return item;

        for (const { key } of currencyExchangeRateFields) {
            item.rates[key] = latest.rates[key];
        }

        return item;
    }

    toApiData(): Record<string, unknown> {
        const row: Record<string, unknown> = {};

        for (const { key } of currencyExchangeRateFields) {
            const value = this.rates[key];
            row[key] = value == null || value === '' ? '' : String(value);
        }

        return row;
    }
}
